import Event from '../../core/Event';
import { OrderDocumentType } from '../../../view/order/UserOrder';

export default class OrderDocumentGetFailed extends Event {
    public static type = 'OrderDocumentGetFailed';

    constructor(public readonly documentType: OrderDocumentType, public readonly documentId: string) {
        super(OrderDocumentGetFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderDocumentGetFailed.ts